import React from 'react'
import { useTranslate, Loading, usePermissions } from 'react-admin'
// import WidgetDashboard from './WidgetDashboard'
import ProductWidgetDashboard from './ProductWidgetDashboard'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
// import SettingsAccessibilityRoundedIcon from '@mui/icons-material/SettingsAccessibilityRounded'
// import TireRepairIcon from '@mui/icons-material/TireRepair'
import Tire from '../../components/icons/Tire'
import Lubricant from '../../components/icons/Lubricant'
import Battery from '../../components/icons/Battery'
import Break from '../../components/icons/Break'
import Shock from '../../components/icons/Shock'
import Other from '../../components/icons/Other'
// import FeedRoundedIcon from '@mui/icons-material/FeedRounded'
// import LastLoginUser from './LastLoginUser'

import {
  PRODUCTS_TIRE_FIELDS,
  PRODUCTS_LUBRICANT_FIELDS,
  PRODUCTS_BATTERY_FIELDS,
  PRODUCTS_BRAKE_FIELDS,
  PRODUCTS_SHOCK_FIELDS,
  PRODUCTS_OTHER_FIELDS,
  // PRODUCTS_COMMON_FIELDS,
  // COMMON_FIELDS,
} from '../../providers/localization/constant'

const Dashboard: React.FC = () => {
  const translate = useTranslate()
  const { /* permissions,*/ isLoading } = usePermissions()
  if (isLoading) {
    return <Loading />
  }

  // const permissionNews = permissions.find((permission) => permission.key == 'news_management')

  return (
    <Container maxWidth='xl' sx={{ pt: '60px' }}>
      <Grid container spacing={3}>
        {/* <Grid item xs={12} sm={6} md={4}>
          <WidgetDashboard
            Icon={SettingsAccessibilityRoundedIcon}
            resource='admins-count'
            title='Admin'
            color='warning'
            resourceOptions={{
              filter: {},
              sort: { field: 'create_at', order: 'desc' },
            }}
          />
        </Grid> */}
        <Grid item xs={12} sm={6} md={4}>
          <ProductWidgetDashboard
            Icon={Tire}
            resource='products-tire-count'
            title={translate(`${PRODUCTS_TIRE_FIELDS}.name`)}
            color='warning'
            resourceOptions={{
              filter: {},
              sort: { field: 'create_at', order: 'desc' },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ProductWidgetDashboard
            Icon={Lubricant}
            resource='products-shock-count'
            title={translate(`${PRODUCTS_LUBRICANT_FIELDS}.name`)}
            color='warning'
            resourceOptions={{
              filter: {},
              sort: { field: 'create_at', order: 'desc' },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ProductWidgetDashboard
            Icon={Battery}
            resource='products-brake-count'
            title={translate(`${PRODUCTS_BATTERY_FIELDS}.name`)}
            color='warning'
            resourceOptions={{
              filter: {},
              sort: { field: 'create_at', order: 'desc' },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ProductWidgetDashboard
            Icon={Break}
            resource='products-lubricant-count'
            title={translate(`${PRODUCTS_BRAKE_FIELDS}.name`)}
            color='warning'
            resourceOptions={{
              filter: {},
              sort: { field: 'create_at', order: 'desc' },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ProductWidgetDashboard
            Icon={Shock}
            resource='products-battery-count'
            title={translate(`${PRODUCTS_SHOCK_FIELDS}.name`)}
            color='warning'
            resourceOptions={{
              filter: {},
              sort: { field: 'create_at', order: 'desc' },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ProductWidgetDashboard
            Icon={Other}
            resource='products-other-count'
            title={translate(`${PRODUCTS_OTHER_FIELDS}.name`)}
            color='warning'
            resourceOptions={{
              filter: {},
              sort: { field: 'create_at', order: 'desc' },
            }}
          />
        </Grid>
      </Grid>
    </Container>
  )
}

export default Dashboard
